import { NameSpacing } from '../../Common/Utils/NameSpacing'

export const NOTIFICATIONS = 'settings'
export const UserNotifications = 'preferences'

export enum NotificaionTabFieldNames {
    DO_NOT_DISTURB = 'doNotDisturb',
    CME = 'cme',
    TELEPHONY_SERVER = 'telSysID',
    PARTITION = 'partitionIDInTelSys',
    DEVICE_NUMBER = 'deviceNumber',
    CHANNELS = 'channels',
    PHONE_NUMBER = 'telephoneNumber'
}

export enum NotificationUserFiels {
    Name = 'Name',
    NotificationEnabled = 'NotificationEnabled',
    Threshold = 'Threshold'
}

export const NotificationNameSpacing: (fieldName: string) => string = (fieldName: string): string =>
    NameSpacing(NOTIFICATIONS, fieldName)

export const NotificationUserFieldNameSpacing: (fieldName: string) => string = (fieldName: string): string =>
    NameSpacing(UserNotifications, fieldName)

export const DO_NOT_DISTURB_NAME: string = NotificationNameSpacing(NotificaionTabFieldNames.DO_NOT_DISTURB)
export const CME_SCOPE_NAME: string = NotificationNameSpacing(NotificaionTabFieldNames.CME)
export const TELEPHONY_SERVER_SCOPE_NAME: string = NotificationNameSpacing(NotificaionTabFieldNames.TELEPHONY_SERVER)
export const PARTITION_SCOPE_NAME: string = NotificationNameSpacing(NotificaionTabFieldNames.PARTITION)
export const DEVICE_SCOPE_NAME: string = NotificationNameSpacing(NotificaionTabFieldNames.DEVICE_NUMBER)
export const NOTIFICATION_CHANNEL_NAME: string = NotificationNameSpacing(NotificaionTabFieldNames.CHANNELS)
export const NOTIFICATION_PHONE_NUMBER_NAME: string = NotificationNameSpacing(NotificaionTabFieldNames.PHONE_NUMBER)
